import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {SaleRetrocessionModel} from '../saleRetrocession.model';
import {SaleProductSummaryConverter} from '../../../../product/api/converter/saleProductSummary.converter';
import {UserSummaryConverter} from "../../../../../../account/modules/user/api/converter/userSummary.converter";

@Injectable()
export class SaleRetrocessionConverter extends HttpModelConverter<SaleRetrocessionModel> {

    constructor(private saleProductSummaryConverter: SaleProductSummaryConverter,
                private userSummaryConverter: UserSummaryConverter) {
        super();
    }

    protected createInstance(): SaleRetrocessionModel {
        return new SaleRetrocessionModel();
    }

    protected enrichObject(result: SaleRetrocessionModel, src: SaleRetrocessionModel) {
        result.saleProduct = this.saleProductSummaryConverter.convert(src.saleProduct);
        result.saleResponsibleUser = this.userSummaryConverter.convert(src.saleResponsibleUser);
    }

}

